import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  BsArrowDownLeft,
  BsArrowLeftRight,
  BsArrowUpRight,
  BsReceipt,
  BsRepeat,
  BsTruck,
} from "react-icons/bs";
import {
  faHome,
  faBox,
  faCog,
  faChevronDown,
  faCubes,
  faBuilding,
  faBalanceScale,
  faTag,
  faUsers,
  faLocationArrow,
  faUserGroup,
  faRecycle,
  faIndustry,
  faSignOutAlt,
  faBagShopping,
  faUpDown,
  faWarehouse,
  faHandHoldingDollar,
  faHandHoldingHand,
  faArrowsDownToLine,
  faArrowsAltV,
} from "@fortawesome/free-solid-svg-icons";
import { FiShoppingBag } from "react-icons/fi";
import { GoNote } from "react-icons/go";
import { FaShoppingCart, FaPeopleCarry  } from "react-icons/fa";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia"
import { useNavigate } from "react-router-dom";
import { MdOutlineCreditCard, MdOutlinePayments } from "react-icons/md";
import { RiSecurePaymentFill } from "react-icons/ri";
import { FaClipboardCheck } from "react-icons/fa";
import { IoReceiptOutline } from "react-icons/io5";

const Sidebar = ({ onContentChange }) => {
  const [isInventoryOpen, setInventoryOpen] = useState(false);
  const [isProductionOpen, setProductionOpen] = useState(false);
  const [isOrdersOpen, setOrdersOpen] = useState(false);
  const [isStockOnLoanOpen, setStockOnLoanOpen] = useState(false);
  const [isReportsOpen, setReportsOpen] = useState(false);
  const [isPayemetsOpen, setPayementOpen] = useState(false);
  const [isPurchasingOpen, setPurchasingOpen] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState("user-dashboard");
  const [userRole, setUserRole] = useState(""); // State to hold user role

  const navigate = useNavigate();

  // Fetch role from localStorage
  useEffect(() => {
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);

  const toggleInventoryDropdown = () => {
    setInventoryOpen(!isInventoryOpen);
  };

  const toggleProductionDropdown = () => {
    setProductionOpen(!isProductionOpen);
  };

  const toggleOrdersDropdown = () => {
    setOrdersOpen(!isOrdersOpen);
  };

  const toggleStockonLoanDropdown = () => {
    setStockOnLoanOpen(!isStockOnLoanOpen);
  };

  const togglePaymentDropdown = () => {
    setPayementOpen(!isPayemetsOpen);
  };

  const togglePurchasingDropdown = () => {
    setPurchasingOpen(!isPurchasingOpen);
  };

  const toggleReportsDropdown = () => {
    setReportsOpen(!isReportsOpen);
  };

  const handleMenuItemClick = (menuItem) => {
    setActiveMenuItem(menuItem);
    onContentChange(menuItem);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("role");
    navigate("/login", { replace: true });
  };

  return (
    <div className="w-70 bg-gray-800 text-white flex flex-col overflow-y-auto h-screen">
      {/* Highlighted IMS Dashboard label */}
      <div className="p-4 text-xl font-bold bg-gray-900 flex items-center">
        FMS Dashboard
        <img src="/agro_farm_ims_logo.png" alt="logo" className="ml-4 h-12 w-12" />
      </div>

      <nav className="flex-grow overflow-y-auto">
        <button
          onClick={() => handleMenuItemClick("user-dashboard")}
          className={`flex items-center py-2.5 px-4 rounded w-full text-left ${
            activeMenuItem === "user-dashboard"
              ? "bg-gray-700 text-gray-300"
              : "hover:bg-gray-700"
          }`}
        >
          <FontAwesomeIcon icon={faHome} className="mr-3" />
          Home
        </button>

        {/* Master Data Section */}
        {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Farm User" || userRole === "Outlet User") && (
          <div>
            <button
              onClick={toggleInventoryDropdown}
              className={`flex items-center w-full py-2.5 px-4 rounded focus:outline-none ${
                activeMenuItem === "inventory"
                  ? "bg-gray-700 text-gray-300"
                  : "hover:bg-gray-700"
              }`}
            >
              <FontAwesomeIcon icon={faBox} className="mr-3" />
              Master Data
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-auto transition-transform ${
                  isInventoryOpen ? "transform rotate-180" : ""
                }`}
              />
            </button>

            {isInventoryOpen && (
              <div className="pl-8">
                {/* Check for Farm User role to limit access */}
                {userRole === "Farm User" || userRole == "Outlet User" ? (
                  <>
                    <button
                      onClick={() => handleMenuItemClick("customers")}
                      className={`flex items-center py-2 px-4 rounded w-full text-left ${
                        activeMenuItem === "customers"
                          ? "bg-gray-700 text-gray-300"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      <FontAwesomeIcon icon={faUserGroup} className="mr-3" />
                      Customers
                    </button>
                    <button
                      onClick={() => handleMenuItemClick("products")}
                      className={`flex items-center py-2 px-4 rounded w-full text-left ${
                        activeMenuItem === "products"
                          ? "bg-gray-700 text-gray-300"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      <FontAwesomeIcon icon={faCubes} className="mr-3" />
                      Products
                    </button>
                  </>
                  // Farm User only sees Customers tab
                  
                ) : (
                  // Main Admin and Company Admin see all tabs including Customers
                  <>
                    <button
                      onClick={() => handleMenuItemClick("products")}
                      className={`flex items-center py-2 px-4 rounded w-full text-left ${
                        activeMenuItem === "products"
                          ? "bg-gray-700 text-gray-300"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      <FontAwesomeIcon icon={faCubes} className="mr-3" />
                      Products
                    </button>
                    <button
                      onClick={() => handleMenuItemClick("customers")}
                      className={`flex items-center py-2 px-4 rounded w-full text-left ${
                        activeMenuItem === "customers"
                          ? "bg-gray-700 text-gray-300"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      <FontAwesomeIcon icon={faUserGroup} className="mr-3" />
                      Customers
                    </button>
                    <button
                      onClick={() => handleMenuItemClick("suppliers")}
                      className={`flex items-center py-2 px-4 rounded w-full text-left ${
                        activeMenuItem === "suppliers"
                          ? "bg-gray-700 text-gray-300"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      <FaPeopleCarry icon={faUserGroup} className="mr-3" />
                      Suppliers
                    </button>
                    <button
                      onClick={() => handleMenuItemClick("locations")}
                      className={`flex items-center py-2 px-4 rounded w-full text-left ${
                        activeMenuItem === "locations"
                          ? "bg-gray-700 text-gray-300"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      <FontAwesomeIcon icon={faLocationArrow} className="mr-3" />
                      Locations
                    </button>
                    <button
                      onClick={() => handleMenuItemClick("users")}
                      className={`flex items-center py-2 px-4 rounded w-full text-left ${
                        activeMenuItem === "users"
                          ? "bg-gray-700 text-gray-300"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      <FontAwesomeIcon icon={faUsers} className="mr-3" />
                      Users
                    </button>
                    <button
                      onClick={() => handleMenuItemClick("product-categories")}
                      className={`flex items-center py-2 px-4 rounded w-full text-left ${
                        activeMenuItem === "product-categories"
                          ? "bg-gray-700 text-gray-300"
                          : "hover:bg-gray-700"
                      }`}
                    >
                      <FontAwesomeIcon icon={faTag} className="mr-3" />
                      Category
                    </button>

                    {/* Additional tabs for Main Admin */}
                    {userRole === "Main Admin" && (
                      <>
                        <button
                          onClick={() => handleMenuItemClick("units")}
                          className={`flex items-center py-2 px-4 rounded w-full text-left ${
                            activeMenuItem === "units"
                              ? "bg-gray-700 text-gray-300"
                              : "hover:bg-gray-700"
                          }`}
                        >
                          <FontAwesomeIcon icon={faBalanceScale} className="mr-3" />
                          Units
                        </button>
                        <button
                          onClick={() => handleMenuItemClick("organizations")}
                          className={`flex items-center py-2 px-4 rounded w-full text-left ${
                            activeMenuItem === "organizations"
                              ? "bg-gray-700 text-gray-300"
                              : "hover:bg-gray-700"
                          }`}
                        >
                          <FontAwesomeIcon icon={faBuilding} className="mr-3" />
                          Organizations
                        </button>
                      </>
                    )}

                    {/* Cluster Management for Main Admin */}
                    {(userRole === "Main Admin" || userRole === "Company Admin") && (
                      <button
                        onClick={() => handleMenuItemClick("clusters")}
                        className={`flex items-center py-2 px-4 rounded w-full text-left ${
                          activeMenuItem === "clusters"
                            ? "bg-gray-700 text-gray-300"
                            : "hover:bg-gray-700"
                        }`}
                      >
                        <FontAwesomeIcon icon={faArrowsAltV} className="mr-3" />
                        Clusters
                      </button>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        )}
        {/* Production Section */}
        {userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Farm User" || userRole === "Outlet User" ? (
          <div>
            <button
              onClick={toggleProductionDropdown}
              className={`flex items-center w-full py-2.5 px-4 rounded focus:outline-none ${
                activeMenuItem === "production"
                  ? "bg-gray-700 text-gray-300"
                  : "hover:bg-gray-700"
              }`}
            >
              <FontAwesomeIcon icon={faIndustry} className="mr-3" />
              Production
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-auto transition-transform ${
                  isProductionOpen ? "transform rotate-180" : ""
                }`}
              />
            </button>

            {isProductionOpen && (
              <div>
              {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Farm User") && (
                <>
                <div className="pl-8">
                  <button
                    onClick={() => handleMenuItemClick("production-batch")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                      activeMenuItem === "production-batch"
                        ? "bg-gray-700 text-gray-300"
                        : "hover:bg-gray-700"
                    }`}
                  >
                    <FontAwesomeIcon icon={faRecycle} className="mr-3" />
                    Production Batch
                  </button>
                </div>
                </>
                )}
                <div className="pl-8">
                  <button
                    onClick={() => handleMenuItemClick("stock-adjustment")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                      activeMenuItem === "stock-adjustment"
                        ? "bg-gray-700 text-gray-300"
                        : "hover:bg-gray-700"
                    }`}
                  >
                    <FontAwesomeIcon icon={faUpDown} className="mr-3" />
                    Stock Adjustment
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : null}

        {/* Orders Section */}
        {userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Farm User" || userRole === "Outlet User" ? (
          <div>
            <button
              onClick={toggleOrdersDropdown}
              className={`flex items-center w-full py-2.5 px-4 rounded focus:outline-none ${
              activeMenuItem === "orders"
                ? "bg-gray-700 text-gray-300"
                : "hover:bg-gray-700"
              }`}
            >
            <FontAwesomeIcon icon={faBagShopping} className="mr-3" />
              Orders
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`ml-auto transition-transform ${
                isOrdersOpen ? "transform rotate-180" : ""
              }`}
            />
          </button>
    
          {isOrdersOpen && (
            <div className="pl-8">
            {/* Show full menu for Admins */}
              {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User") && (
                <>
                  <button
                    onClick={() => handleMenuItemClick("order-cycle")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "order-cycle"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <BsRepeat className="mr-3" />
                    Order Cycle
                  </button>
                </>
              )}
              {/* Show only "Order Request" for Farm Users */}
              {(userRole === "Farm User" || userRole === "Company Admin" || userRole === "Main Admin" || userRole === "Outlet User") && (
                <>
                <button
                    onClick={() => handleMenuItemClick("order-request")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "order-request"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <BsArrowDownLeft className="mr-3" />
                  Order Requests
                  </button>
                </>
              )}
              {/* Show full menu for Admins */}
              {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User") && (
                <>
                <button
                    onClick={() => handleMenuItemClick("sales-orders")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "sales-orders"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <BsArrowUpRight className="mr-3" />
                    Sales Orders
                  </button>
                  {/* <button
                    onClick={() => handleMenuItemClick("invoices")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                      activeMenuItem === "invoices"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <LiaFileInvoiceDollarSolid className="mr-3" />
                    Invoice
                  </button> */}
                </>
              )}

              {/* Show only "Transfer Orders" for Farm Users */}
              {(userRole === "Farm User" || userRole === "Company Admin") && (
                <>
                <button
                  onClick={() => handleMenuItemClick("transfer-orders")}
                  className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "transfer-orders"
                    ? "bg-gray-700 text-gray-300"
                    : "hover:bg-gray-700"
                  }`}
                >
                <BsArrowLeftRight className="mr-3" />
                Transfer Orders
                </button>
                </>
              )}

                <button
                  onClick={() => handleMenuItemClick("transfer-order-receipts")}
                  className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "transfer-order-receipts"
                    ? "bg-gray-700 text-gray-300"
                    : "hover:bg-gray-700"
                  }`}
                >
                <BsReceipt className="mr-3" />
                Transfer Order Receipts
                </button>

              
                  <>
                <button
                  onClick={() => handleMenuItemClick("transport-orders")}
                  className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "transport-orders" // Fixed this condition
                    ? "bg-gray-700 text-gray-300"
                    : "hover:bg-gray-700"
                  }`}
                >
                <BsTruck className="mr-3" />
                Transport Orders
              </button>
              </>
            
            </div>
          )}
        </div>
        ) : null}

        {/* Stock on Loan Section */}
        {userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Farm User" || userRole === "Outlet User"? (
          <div>
            <button
              onClick={toggleStockonLoanDropdown}
              className={`flex items-center w-full py-2.5 px-4 rounded focus:outline-none ${
                activeMenuItem === "stock-on-loan"
                  ? "bg-gray-700 text-gray-300"
                  : "hover:bg-gray-700"
              }`}
            >
              <FontAwesomeIcon icon={faHandHoldingDollar} className="mr-3" />
              Stock on Loan
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-auto transition-transform ${
                  isStockOnLoanOpen ? "transform rotate-180" : ""
                }`}
              />
            </button>

            {isStockOnLoanOpen && (
              <div>
                <div className="pl-8">
                  <button
                    onClick={() => handleMenuItemClick("dispatched-stock-on-loan")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                      activeMenuItem === "dispatched-stock-on-loan"
                        ? "bg-gray-700 text-gray-300"
                        : "hover:bg-gray-700"
                    }`}
                  >
                    <FaClipboardCheck className="mr-3" />
                     Dispatched 
                  </button>
                  <button
                    onClick={() => handleMenuItemClick("incoming-stock-on-loan")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                      activeMenuItem === "incoming-stock-on-loan"
                        ? "bg-gray-700 text-gray-300"
                        : "hover:bg-gray-700"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowsDownToLine} className="mr-3" />
                     Incoming 
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : null}

        {(userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User" || userRole === "Accountant") ? (
          <div>
            <button
            onClick={() => togglePaymentDropdown()}
            className={`flex items-center w-full py-2.5 px-4 rounded focus:outline-none ${
              activeMenuItem === "payments"
                ? "bg-gray-700 text-gray-300"
                : "hover:bg-gray-700"
            }`}
          >
            < RiSecurePaymentFill className="mr-3" />
            Payments
            <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-auto transition-transform ${
                  isPayemetsOpen ? "transform rotate-180" : ""
                }`}
              />
          </button>

          {isPayemetsOpen && (
            <div className="pl-8">
              {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User" || userRole === "Accountant") && (
                <>
                  <button
                    onClick={() => handleMenuItemClick("invoices")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                      activeMenuItem === "invoices"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <LiaFileInvoiceDollarSolid className="mr-3" />
                    Invoice
                  </button>
                  <button
                    onClick={() => handleMenuItemClick("payment")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "payment"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <MdOutlinePayments className="mr-3" />
                    Payment Receipts
                  </button>
                  
                  <button
                    onClick={() => handleMenuItemClick("credit-note")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "credit-note"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <MdOutlineCreditCard className="mr-3" />
                    Credit Notes
                  </button>

                  <button
                    onClick={() => handleMenuItemClick("settelments")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "settelments"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <IoReceiptOutline className="mr-3" />
                  Settlements
                  </button>
                </>
              )}
              {/* {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User") && (
                <>
                  <button
                    onClick={() => handleMenuItemClick("settelments")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "settelments"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <IoReceiptOutline className="mr-3" />
                  Settlements
                  </button>
                </>
              )} */}
            </div>
          )}
          </div>
        ) : null}

        {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Accountant") ? (
          <div>
            <button
            onClick={() => togglePurchasingDropdown()}
            className={`flex items-center w-full py-2.5 px-4 rounded focus:outline-none ${
              activeMenuItem === "purchasing"
                ? "bg-gray-700 text-gray-300"
                : "hover:bg-gray-700"
            }`}
          >
            < FaShoppingCart className="mr-3" />
            Purchasing
            <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-auto transition-transform ${
                  isPurchasingOpen ? "transform rotate-180" : ""
                }`}
              />
          </button>

          {isPurchasingOpen && (
            <div className="pl-8">
              {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Accountant") && (
                <>
                  <button
                    onClick={() => handleMenuItemClick("purchase-orders")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "purchase-orders"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <FiShoppingBag className="mr-3" />
                      Purchase Order
                  </button>
                </>
              )}
              {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Accountant") && (
                <>
                  <button
                    onClick={() => handleMenuItemClick("goods-receipt-note")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "goods-receipt-note"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <GoNote className="mr-3" />
                   Good Receipt Note
                  </button>
                </>
              )}
              {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Accountant") && (
                <>
                  <button
                    onClick={() => handleMenuItemClick("purchase-invoices")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === "purchase-invoices"
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <LiaFileInvoiceDollarSolid className="mr-3" />
                    Purchasing Invoice
                  </button>
                </>
              )}
              {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Accountant") && (
                <>
                  <button
                    //onClick={() => handleMenuItemClick("settelments")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                    activeMenuItem === ""
                      ? "bg-gray-700 text-gray-300"
                      : "hover:bg-gray-700"
                    }`}
                  >
                  <MdOutlinePayments className="mr-3" />
                   Payments
                  </button>
                </>
              )}
            </div>
          )}
          </div>
        ) : null}


        {/* Report Section */}
        {userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Farm User" || userRole === "Outlet User"? (
          <div>
            <button
              onClick={toggleReportsDropdown}
              className={`flex items-center w-full py-2.5 px-4 rounded focus:outline-none ${
                activeMenuItem === "reports"
                  ? "bg-gray-700 text-gray-300"
                  : "hover:bg-gray-700"
              }`}
            >
              <FontAwesomeIcon icon={faIndustry} className="mr-3" />
              Reports
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ml-auto transition-transform ${
                  isReportsOpen ? "transform rotate-180" : ""
                }`}
              />
            </button>

            {isReportsOpen && (
              <div>
                <div className="pl-8">
                  <button
                    onClick={() => handleMenuItemClick("stock-view")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                      activeMenuItem === "stock-view"
                        ? "bg-gray-700 text-gray-300"
                        : "hover:bg-gray-700"
                    }`}
                  >
                    <FontAwesomeIcon icon={faWarehouse} className="mr-3" />
                     Stock
                  </button>
                </div>
                <div className="pl-8">
                  <button
                    onClick={() => handleMenuItemClick("stock-movement")}
                    className={`flex items-center py-2 px-4 rounded w-full text-left ${
                      activeMenuItem === "stock-movement"
                        ? "bg-gray-700 text-gray-300"
                        : "hover:bg-gray-700"
                    }`}
                  >
                    <FontAwesomeIcon icon={faArrowsAltV} className="mr-3" />
                     Stock Movement
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : null}

        {/* Reports Section
        {(userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Farm User") && (
          <button
            onClick={() => handleMenuItemClick("reports")}
            className={`flex items-center py-2 px-4 rounded w-full text-left ${
              activeMenuItem === "reports"
                ? "bg-gray-700 text-gray-300"
                : "hover:bg-gray-700"
            }`}
          >
            <FontAwesomeIcon icon={faFileAlt} className="mr-3" />
            Reports
          </button>
        )} */}

        {/* Settings Section */}
        {(userRole === "Main Admin" || userRole === "Company Admin") && (
          <div className="bottom-200">
          <button
            onClick={() => handleMenuItemClick("settings")}
            className={`flex mb-20 items-center py-2 px-4 rounded w-full text-left ${
              activeMenuItem === "settings"
                ? "bg-gray-700 text-gray-300"
                : "hover:bg-gray-700"
            }`}
          >
            <FontAwesomeIcon icon={faCog} className="mr-3" />
            Settings
          </button>
          </div>        
        )}

        
      </nav>
      <div className="py-2 bg-gray-900 flex items-center">
        <button
          onClick={handleLogout}
          className="flex items-center py-2 px-4 w-full bg-gray-900 text-left hover:bg-gray-950 focus:outline-none"
        >
          <FontAwesomeIcon icon={faSignOutAlt} className="mr-3" />
            Logout
        </button>
      </div>
      {/* Logout Button */}
      {/* <div className="absolute w-full bottom-0 ">
          <button
            onClick={handleLogout}
            className="flex items-center py-2 px-4 w-full bg-gray-900 text-left hover:bg-gray-950 focus:outline-none"
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="mr-3" />
            Logout
          </button>
        </div> */}
    </div>
  );
};

export default Sidebar;
